// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_array from "@rescript/std/lib/es6/js_array.js";

var Raw = {};

var query = (require("@apollo/client").gql`
  fragment TextField on TextFieldContentType   {
    __typename
    system  {
      __typename
      id
      codename
    }
    name  {
      __typename
      value
    }
    type  {
      __typename
      value  {
        __typename
        codename
      }
    }
    label  {
      __typename
      value
    }
    placeholder  {
      __typename
      value
    }
    validation_message  {
      __typename
      value
    }
    required  {
      __typename
      value  {
        __typename
        codename
      }
    }
  }
`);

function parse(value) {
  var value$1 = value.system;
  var value$2 = value.name;
  var tmp;
  if (value$2 == null) {
    tmp = undefined;
  } else {
    var value$3 = value$2.value;
    tmp = {
      __typename: value$2.__typename,
      value: !(value$3 == null) ? value$3 : undefined
    };
  }
  var value$4 = value.type;
  var tmp$1;
  if (value$4 == null) {
    tmp$1 = undefined;
  } else {
    var value$5 = value$4.value;
    tmp$1 = {
      __typename: value$4.__typename,
      value: !(value$5 == null) ? Js_array.map((function (value) {
                if (value == null) {
                  return ;
                }
                var value$1 = value.codename;
                return {
                        __typename: value.__typename,
                        codename: !(value$1 == null) ? value$1 : undefined
                      };
              }), value$5) : undefined
    };
  }
  var value$6 = value.label;
  var tmp$2;
  if (value$6 == null) {
    tmp$2 = undefined;
  } else {
    var value$7 = value$6.value;
    tmp$2 = {
      __typename: value$6.__typename,
      value: !(value$7 == null) ? value$7 : undefined
    };
  }
  var value$8 = value.placeholder;
  var tmp$3;
  if (value$8 == null) {
    tmp$3 = undefined;
  } else {
    var value$9 = value$8.value;
    tmp$3 = {
      __typename: value$8.__typename,
      value: !(value$9 == null) ? value$9 : undefined
    };
  }
  var value$10 = value.validation_message;
  var tmp$4;
  if (value$10 == null) {
    tmp$4 = undefined;
  } else {
    var value$11 = value$10.value;
    tmp$4 = {
      __typename: value$10.__typename,
      value: !(value$11 == null) ? value$11 : undefined
    };
  }
  var value$12 = value.required;
  var tmp$5;
  if (value$12 == null) {
    tmp$5 = undefined;
  } else {
    var value$13 = value$12.value;
    tmp$5 = {
      __typename: value$12.__typename,
      value: !(value$13 == null) ? Js_array.map((function (value) {
                if (value == null) {
                  return ;
                }
                var value$1 = value.codename;
                return {
                        __typename: value.__typename,
                        codename: !(value$1 == null) ? value$1 : undefined
                      };
              }), value$13) : undefined
    };
  }
  return {
          __typename: value.__typename,
          system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
          },
          name: tmp,
          type: tmp$1,
          label: tmp$2,
          placeholder: tmp$3,
          validation_message: tmp$4,
          required: tmp$5
        };
}

function serialize(value) {
  var value$1 = value.required;
  var required;
  if (value$1 !== undefined) {
    var value$2 = value$1.value;
    var value$3 = value$2 !== undefined ? Js_array.map((function (value) {
              if (value === undefined) {
                return null;
              }
              var value$1 = value.codename;
              var codename = value$1 !== undefined ? value$1 : null;
              var value$2 = value.__typename;
              return {
                      __typename: value$2,
                      codename: codename
                    };
            }), value$2) : null;
    var value$4 = value$1.__typename;
    required = {
      __typename: value$4,
      value: value$3
    };
  } else {
    required = null;
  }
  var value$5 = value.validation_message;
  var validation_message;
  if (value$5 !== undefined) {
    var value$6 = value$5.value;
    var value$7 = value$6 !== undefined ? value$6 : null;
    var value$8 = value$5.__typename;
    validation_message = {
      __typename: value$8,
      value: value$7
    };
  } else {
    validation_message = null;
  }
  var value$9 = value.placeholder;
  var placeholder;
  if (value$9 !== undefined) {
    var value$10 = value$9.value;
    var value$11 = value$10 !== undefined ? value$10 : null;
    var value$12 = value$9.__typename;
    placeholder = {
      __typename: value$12,
      value: value$11
    };
  } else {
    placeholder = null;
  }
  var value$13 = value.label;
  var label;
  if (value$13 !== undefined) {
    var value$14 = value$13.value;
    var value$15 = value$14 !== undefined ? value$14 : null;
    var value$16 = value$13.__typename;
    label = {
      __typename: value$16,
      value: value$15
    };
  } else {
    label = null;
  }
  var value$17 = value.type;
  var type_;
  if (value$17 !== undefined) {
    var value$18 = value$17.value;
    var value$19 = value$18 !== undefined ? Js_array.map((function (value) {
              if (value === undefined) {
                return null;
              }
              var value$1 = value.codename;
              var codename = value$1 !== undefined ? value$1 : null;
              var value$2 = value.__typename;
              return {
                      __typename: value$2,
                      codename: codename
                    };
            }), value$18) : null;
    var value$20 = value$17.__typename;
    type_ = {
      __typename: value$20,
      value: value$19
    };
  } else {
    type_ = null;
  }
  var value$21 = value.name;
  var name;
  if (value$21 !== undefined) {
    var value$22 = value$21.value;
    var value$23 = value$22 !== undefined ? value$22 : null;
    var value$24 = value$21.__typename;
    name = {
      __typename: value$24,
      value: value$23
    };
  } else {
    name = null;
  }
  var value$25 = value.system;
  var value$26 = value$25.codename;
  var value$27 = value$25.id;
  var value$28 = value$25.__typename;
  var system = {
    __typename: value$28,
    id: value$27,
    codename: value$26
  };
  var value$29 = value.__typename;
  return {
          __typename: value$29,
          system: system,
          name: name,
          type: type_,
          label: label,
          placeholder: placeholder,
          validation_message: validation_message,
          required: required
        };
}

function verifyArgsAndParse(_TextField, value) {
  return parse(value);
}

function verifyName(param) {
  
}

var TextField = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  verifyArgsAndParse: verifyArgsAndParse,
  verifyName: verifyName
};

export {
  TextField ,
}
/* query Not a pure module */
